/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'link': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M32.799 21.854l-2.133 2.132a6.505 6.505 0 0 0-1.559-2.683l1.57-1.571c.562-.56.299-1.519-.266-2.084l-1.641-1.64c-.518-.518-1.358-.79-1.983-.165l-5.245 5.244c-.597.598-.379 1.443.146 1.978v-.001l.022.025 2.805 2.805-2.121 2.121-2.805-2.804-.01-.011-.008-.01-.005-.004c-1.778-1.793-1.844-4.521-.145-6.221l5.245-5.244c1.699-1.699 4.435-1.627 6.226.164l1.641 1.641c1.848 1.848 1.965 4.627.266 6.328zm-7.563-2.311l-.014-.013-2.122 2.121.015.014 2.7 2.699c.566.566.827 1.523.266 2.086l-5.244 5.244c-.566.566-1.528.307-2.093-.26l-1.641-1.639c-.533-.533-.758-1.389-.156-1.99l1.559-1.559a6.241 6.241 0 0 1-1.582-2.661l-2.098 2.098c-1.704 1.704-1.635 4.442.156 6.233l1.64 1.64c1.818 1.817 4.661 1.935 6.336.259l5.245-5.244c1.699-1.699 1.582-4.479-.267-6.328l-2.7-2.7z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/link.js